import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchSortString} from "../../list/constants/SearchSort";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";

export const trackAmplitudeListingSort = (sortOption: SearchSortString, latestQuery: IOfferListLatestQuery) => {
    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery);

    trackAmplitudeEvent("listing_sort", {
        sort_by: SORT_BY_MAP[sortOption],
        listing_type: "rp_listing_sort",
        ...(item_list_id ? {item_list_id} : {})
    });
};

const SORT_BY_MAP: Record<SearchSortString, string> = {
    [SearchSortString.DEFAULT]: "recommended",
    [SearchSortString.LATEST]: "date_desc",
    [SearchSortString.PRICE]: "price_asc",
    [SearchSortString.PRICE_M2]: "price_per_sqm_asc",
    [SearchSortString.CONSTRUCTION_DATE]: "completion_date_asc"
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchSortString} from "../../list/constants/SearchSort";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../list/helpers/offer_listing_amplitude_item_list_id";
import {IOfferListLatestQuery} from "../../list/types/IOfferListLatestQuery";

export const trackAmplitudeListingSort = (sortOption: SearchSortString, latestQuery: IOfferListLatestQuery) => {
    const item_list_id = getOrCreateOfferListingAmplitudeItemListId(latestQuery);

    trackAmplitudeEvent("listing_sort", {
        sort_by: SORT_BY_MAP[sortOption],
        listing_type: "rp_listing_sort",
        ...(item_list_id ? {item_list_id} : {})
    });
};

const SORT_BY_MAP: Record<SearchSortString, string> = {
    [SearchSortString.DEFAULT]: "recommended",
    [SearchSortString.LATEST]: "date_desc",
    [SearchSortString.PRICE]: "price_asc",
    [SearchSortString.PRICE_M2]: "price_per_sqm_asc",
    [SearchSortString.CONSTRUCTION_DATE]: "completion_date_asc"
};
